// Safe access to process.env (only REACT_APP_* vars are available in React)
const getEnv = (key) => {
    if (typeof process !== 'undefined' && process.env) {
        return process.env[key];
    }
    return undefined;
};

const MIX_JWT_TOKEN = getEnv('MIX_JWT_TOKEN');
const MIX_API_OPINIONS_MICROSERVICE_URL = getEnv('MIX_API_OPINIONS_MICROSERVICE_URL');
const MIX_PUSHER_APP_KEY = getEnv('MIX_PUSHER_APP_KEY');
const REACT_APP_API_URL = getEnv('REACT_APP_API_URL');
const REACT_APP_CONEKTA_PUBLIC_KEY = getEnv('REACT_APP_CONEKTA_PUBLIC_KEY');
const REACT_APP_CFDI_API_URL = getEnv('REACT_APP_CFDI_API_URL');
const REACT_APP_STRIPE_KEY_TEST = getEnv('REACT_APP_STRIPE_KEY_TEST');
const REACT_APP_STRIPE_SECRET_TEST = getEnv('REACT_APP_STRIPE_SECRET_TEST');
const REACT_APP_APP_URL = getEnv('REACT_APP_APP_URL');

export const API_HOST = REACT_APP_API_URL;
export const APP_HOST = REACT_APP_APP_URL;
export const API_CFDI = REACT_APP_CFDI_API_URL;
export const TOKEN = MIX_JWT_TOKEN;
export const CONEKTA_KEY = REACT_APP_CONEKTA_PUBLIC_KEY;
export const API_MICROSERVICE_OPINION_HOST = MIX_API_OPINIONS_MICROSERVICE_URL;
export const PUSHER_KEY = MIX_PUSHER_APP_KEY;
export const KEY_TEST = REACT_APP_STRIPE_KEY_TEST;
export const CLIENT_SECRET = REACT_APP_STRIPE_SECRET_TEST;
